import { httpRequest } from "../../http"

export interface ArchiveEngagementResult {
  engagement_id: number
  network: string | null
  marked: {
    campaign: number
    audience: number
    ad_group: number
    ad: number
  }
}

export class CommandArchiveEngagement {
  async run(engagementId: number, network?: string): Promise<ArchiveEngagementResult> {
    const query = network ? `?network=${encodeURIComponent(network)}` : ""
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/archive/${query}`
    const response = await httpRequest<ArchiveEngagementResult>(url, {
      method: "POST",
    })
    return response
  }
}
